import { api, unwrap } from '@/api/http'
import type {
  BigshipShipmentResult,
  BigshipTrackingResult,
  CreateShipmentPayload,
} from '../types/shipping.types'

export const shippingService = {
  createShipment: (orderId: number, payload?: CreateShipmentPayload) =>
    api
      .post<BigshipShipmentResult>(`/shipping/orders/${orderId}/create-shipment`, payload || {})
      .then(unwrap),

  getTracking: (awb: string) =>
    api.get<BigshipTrackingResult>(`/shipping/track/${encodeURIComponent(awb)}`).then(unwrap),

  advanceStatus: (
    orderId: number,
    data: { status: string; location?: string; activity?: string }
  ) => api.patch<any>(`/shipping/orders/${orderId}/advance-status`, data).then(unwrap),

  getLabelUrl: (orderId: number) => {
    const apiBase = import.meta.env.VITE_API_URL || '/api/v1'
    return `${apiBase}/shipping/orders/${orderId}/label`
  },
}
